<template>
  <div class="g-page">
    <div class="content-container">
      <taminotchi-form :datas="dataall"></taminotchi-form>
    </div>
  </div>
</template>

<script>
import TaminotchiForm from "./Form.vue";
import axios from "axios";

export default {
  components: { TaminotchiForm },
  data() {
    return {
      loading: false,
      dataall: {
        name: "", phone_number: "", parent_id: 0, address: "",
        inn: "", mfo_id: "", is_folder: false, type: 2, 
        comment: "",
        password: "123456",
        sklad_id: parseInt(localStorage.getItem('sklad_id')) || 0

      }
    };
  },
  methods: {
    async saveData() {
      this.loading = true;
      try {
        await axios.post("api/v1/kontragent", this.dataall);
        this.$router.push("/malumot/taminotchi/index");
      } catch (err) {
        alert("Xatolik yuz berdi");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>